export const AMOUNT_PAID = '+';
export const AMOUNT_COLLECTED = '-';
export const PENALTY_YES = 'S';
export const PENALTY_NO = 'N';
export const COMI_VENTAS = 'CV';
export const COMI_SEGURO_VIDA = '01';
export const COMI_SEGURO_PAGO = '02';
export const RAPPEL = 'Rappel';
export const RAPPEL_SIGLAS = 'RP';
